import { getAllServices } from './alerts.service';

class BackgroundService {
    constructor() {
        this.intervalId = null;
        this.isRunning = false;
        this.currentUser = null;
        this.onNotificationCallback = null;
        this.checkInterval = 5 * 60 * 1000; // 5 minutes
        this.lastNotificationTime = 0;
        this.notificationCooldown = 2 * 60 * 1000; // 2 minutes cooldown between notifications
        this.notifiedEscalationKeys = new Set();
    }

    start(user, onNotification) {
        if (this.isRunning) {
            this.stop();
        }

        this.currentUser = user;
        this.onNotificationCallback = onNotification;
        this.isRunning = true;

        // Start the monitoring process
        this.monitorServices();
        
        // Set up interval for periodic checks
        this.intervalId = setInterval(() => {
            this.monitorServices();
        }, this.checkInterval);

        console.log('Background service started for user:', user.username);

    }

    stop() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
        this.isRunning = false;
        this.currentUser = null;
        this.onNotificationCallback = null;
        console.log('Background service stopped');
    }

    _isCompletionOtpEscalated(service) {
        const meta = service?.meta_data || {};
        return meta.completion_otp_escalated === true || meta.completion_otp_escalated === 'true';
    }

    async monitorServices() {
        if (!this.isRunning || !this.currentUser) {
            return;
        }

        try {
            const response = await getAllServices();
            const services = response?.items || [];

            // Check for services with "vendor_not_accepted" status created by current user
            const unassignedServices = services.filter(service => 
                service.status === 'vendor_not_accepted' && 
                service.created_by === this.currentUser.id
            );

            // Completion OTP escalations — any agent can act
            const escalatedServices = services.filter((service) =>
                this._isCompletionOtpEscalated(service)
            );
            const newEscalations = escalatedServices.filter((s) => {
                const key = `otp-${s.id}-${s.meta_data?.completion_otp_escalated_at || 'open'}`;
                if (this.notifiedEscalationKeys.has(key)) return false;
                this.notifiedEscalationKeys.add(key);
                return true;
            });
            
            if (!this.onNotificationCallback) {
                return;
            }

            const now = Date.now();
            if (newEscalations.length > 0) {
                this.onNotificationCallback({
                    type: 'completion_otp_escalation',
                    title: 'Completion OTP Failed',
                    message: `Vendor failed completion OTP on ${newEscalations.length} service(s). Review and clear escalation.`,
                    services: newEscalations,
                });
                this.lastNotificationTime = now;
                return;
            }

            if (unassignedServices.length > 0 && now - this.lastNotificationTime > this.notificationCooldown) {
                this.onNotificationCallback({
                    type: 'unassigned_service',
                    title: 'Service Alert',
                    message: 'No vendor accepted the service. assign manually',
                    services: unassignedServices
                });
                this.lastNotificationTime = now;
            }
        } catch (error) {
            // Silent error handling
        }
    }

    // Method to manually trigger a check (useful for testing)
    async checkNow() {
        await this.monitorServices();
    }
}

export const backgroundService = new BackgroundService();
